export default __webpack_public_path__ + "scene4_3_bg936356.png";